import { useTranslation } from "react-i18next";
import styles from "./ProceedToConsent.module.css";

const ProceedToConsent = () => {
  const { t } = useTranslation("registration");

  return (
    <span className={styles.ConsentTextContainer}>
      {t("By proceeding, I consent to Univid's")} &nbsp;
      <a
        className={styles.ConsentLink}
        href="https://univid.io/terms"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("Terms of Use")}
      </a>
      &nbsp;{t("and")}&nbsp;
      <a
        className={styles.ConsentLink}
        href="https://univid.io/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("Privacy Agreement")}
      </a>
    </span>
  );
};

export default ProceedToConsent;
